import * as React from 'react';
import styled from '@emotion/styled';

interface PropsType {
    className?: string
}

const SvgElement = styled('svg', { label: 'SvgElement' })<PropsType>`
    height: auto;
`;

export const EnergyLogo = ( {className}: PropsType ): React.ReactElement => (
    <SvgElement className={className} width='64' height='32' viewBox='0 0 64 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M34.6626 20.9569L38.2835 27.3675H33.2079L29.9438 21.5509H25.8485L24.6918 27.3675H19.8535L24.0096 6.59094H32.4688C37.6326 6.59094 40.6007 8.96502 40.6007 13.0309C40.6007 17.0969 38.3756 19.7983 34.6645 20.955L34.6626 20.9569ZM35.731 13.4779C35.731 11.4606 34.3058 10.5098 31.8435 10.5098H28.0442L26.5895 17.7222H30.6849C33.8607 17.7222 35.731 16.2382 35.731 13.4779Z' fill='#E8E337'/>
        <path d='M56.8372 16.6891H61.2305L59.5092 25.2366C57.4018 26.8402 54.5533 27.7596 51.5558 27.7596C45.2629 27.7596 41.2871 24.1093 41.2871 18.7378C41.2871 11.6449 46.4803 6.27142 54.3455 6.27142C58.3232 6.27142 61.2305 7.54766 63.0125 9.89233L59.57 12.682C58.1742 11.0196 56.4529 10.3667 54.1377 10.3667C49.27 10.3667 46.1529 13.8681 46.1529 18.4398C46.1529 21.5568 48.2309 23.6643 52.1773 23.6643C53.3947 23.6643 54.5219 23.4271 55.6198 22.9233L56.8372 16.6911V16.6891Z' fill='#E8E337'/>
        <path d='M14.9463 17.6026L6.24787 2.4917L0 31.0002L7.85934 16.1049L16.7538 32L23.184 0L14.9463 17.6026Z' fill='#E8E337'/>
    </SvgElement>
);
